import CellTower from "@mui/icons-material/CellTower";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Chip, IconButton, Paper, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ChannelIcon } from "../../channels/components/channel-icon";
import type { MomentWhenClassification } from "../../moment-card/components/moment-card-when";
import { renderMomentWhenContent } from "../../moment-card/components/moment-card-when";
import { statusToPill } from "../../moment-card/utils";
import type { FollowUpMomentDetailsLoaderData } from "../hooks/use-follow-up-moment-details";

export const FollowUpSidebarMomentSummary: FC<{
  followUpMomentDetails: FollowUpMomentDetailsLoaderData["momentFollowUpDetails"];
  whenClassification: MomentWhenClassification;
}> = ({ followUpMomentDetails, whenClassification }) => {
  return (
    <Paper elevation={0} sx={{ p: 2 }}>
      <Stack spacing={1} direction="column">
        <Stack spacing={1} direction="row" alignItems="center">
          <ChannelIcon channel={followUpMomentDetails.channel} fontSize="medium" />
          <Typography variant="subtitle2">{followUpMomentDetails.title}</Typography>
          <IconButton
            href={`/moments/${followUpMomentDetails.id}`}
            target="_blank"
            data-analytics-id="go-to-moment"
          >
            <OpenInNewIcon fontSize="small" color="action" />
          </IconButton>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {followUpMomentDetails.program.title}
        </Typography>
        {whenClassification.type === "triggered" && (
          <Stack spacing={0.5} direction="row" alignItems="center">
            <CellTower fontSize="small" color="action" />
            <Typography variant="overline" fontSize="12px" color="text.secondary">
              Recurring communication
            </Typography>
          </Stack>
        )}
        <Typography variant="body2" color="text.secondary">
          {renderMomentWhenContent(whenClassification)}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          {followUpMomentDetails.segment?.name && (
            <Chip
              label={followUpMomentDetails.segment.name}
              variant="outlined"
              size="small"
              sx={{ width: "fit-content" }}
            />
          )}
          {statusToPill(followUpMomentDetails.status)}
        </Stack>
      </Stack>
    </Paper>
  );
};
